import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const SearchIconSvg = (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.1408 16.1408L20 20M16.1408 16.1408C13.3635 18.9183 8.86042 18.9183 6.08308 16.1408C3.30564 13.3635 3.30564 8.86042 6.08308 6.08308C8.86042 3.30564 13.3635 3.30564 16.1408 6.08308C18.9183 8.86042 18.9183 13.3635 16.1408 16.1408Z"
            stroke="currentColor"/>
    </svg>

)
const SearchIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {SearchIconSvg}
    </SvgIcon>
);
export default SearchIcon